export * from "./ProductMiniature";
